import React from 'react'
import styles from './MiniFeed.scss'
import {Link} from 'react-router'
import {Card} from 'common/styleguide/Card'
import {IntroWidget} from 'common/IntroWidget'
import {MiniListItem, MiniListItemDetail} from '../DashboardElements'
import {ProfileImg} from 'common/ProfileImg'
import {TextWithBolds} from 'common/TextWithBolds'
import smartDate from '@qrohlf/smart-date'
import {AccountTypeBadge} from 'common/AccountTypeBadge'

export class MiniFeed extends React.PureComponent {
  render () {
    const {feedItems} = this.props
    if (!feedItems || feedItems.length === 0) {
      return <Intro />
    }
    return (
      <Card>
        {feedItems.map(f => <FeedItem key={f.id} f={f} />)}
        <Link data-card-link to='/friends'>View Friends</Link>
      </Card>
    )
  }
}

const FeedItem = ({f}) => {
  const subscriptionFeedItem = f.associatedObjectType === 'Subscription'
  return <MiniListItem href={f.content.url}>
    <div style={{display: 'flex'}}>
      <div style={{marginRight: '10px'}}>
        <ProfileImg
          userId={f.content.user_id}
          highlightedPhotoId={f.content.highlighted_photo_id} />
      </div>
      <div>
        {subscriptionFeedItem
          ? <SubscriptionMiniFeedItem userName={f.content.user_name} accountLevel={f.content.account_level} />
          : <TextWithBolds text={f.content.rich_title} />}
        <MiniListItemDetail>
          {smartDate(f.createdAt, {relative: true, includeTime: false})}
        </MiniListItemDetail>
      </div>
    </div>
  </MiniListItem>
}

const Intro = () => (
  <Card>
    <IntroWidget i='md-person-add' link={<a href='/friends'>Add Friends</a>}>
      Add friends to see their rides and unlock more features.
    </IntroWidget>
  </Card>
)

const SubscriptionMiniFeedItem = ({userName, accountLevel}) => {
  const premium = accountLevel === 2
  return <span>
    <strong>{userName}</strong><span> upgraded to </span>
    <strong className={premium && styles.orange}>RWGPS {premium ? 'Premium ' : 'Basic '}</strong>
    <AccountTypeBadge accountLevel={accountLevel} size={14} className={!premium && styles.darkgrey} />
  </span>
}
